import {filterById} from './filterById';
import {findById} from './findById';


export default {
    filterById,
    findById
}